<template>
  <TopNav></TopNav>
  <h1>Kâr Hesaplama</h1>
  <fieldset>
    <legend>Kâr Hesaplama Aracı</legend>
    <label for="vo" class="leftLabel">Alış Fiyatı:</label> <input type="number" v-model.number="alis" step="any" @input="onAlisChange" autofocus id="vo"> <label for="vo">₺</label>
    <br>
    <label for="cu" class="leftLabel">Kâr Oranı:</label> <input type="number" v-model.number="karOrani" step="any" @input="onKarOraniChange" id="cu"> <label for="cu">%</label>
    <br>
    <label for="re" class="leftLabel">Satış Fiyatı:</label> <input type="number" v-model.number="satis" step="any" @input="onSatisChange" id="re"> <label for="re">₺</label>
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Kar",
  data() {
    return {
      alis: 1,
      karOrani: 1,
      satis: 1,
    }
  },
  components: {
    TopNav
  },
  methods: {
    onAlisChange(e) {
      const alis = e.currentTarget.value;
      const alisNumber = Number(alis);
      this.satis = alisNumber + ((alisNumber * this.karOrani) / 100.00);
    },
    onKarOraniChange(e) {
      const karOrani = e.currentTarget.value;
      const karOraniNumber = Number(karOrani);
      this.satis = this.alis + ((this.alis * karOraniNumber) / 100.00);
    },
    onSatisChange(e) {
      const satis = e.currentTarget.value;
      const satisNumber = Number(satis);
      this.karOrani = (satisNumber - this.alis) * 100.00 / this.alis;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
  display: inline-block;
  min-width: 100px;
}

input[type=number] {
    width: 100px;
}

footer section a {
  margin: 20px;
}
</style>
